import {
  type ProgressCircleProps,
  ProgressCircle,
} from '@infinex/ui/components';

type LoadingSpinnerProps = Omit<ProgressCircleProps, 'isIndeterminate'>;

export function LoadingSpinner(props: LoadingSpinnerProps) {
  const ariaLabel = props['aria-label'] ?? 'Loading…';
  return <ProgressCircle {...props} isIndeterminate aria-label={ariaLabel} />;
}
